"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextualArtefactContainerSchema = void 0;
exports.TextualArtefactContainerSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TextualArtefactContainer",
    "description": "A textual artefact containing text, external links, links to resources, etc.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:textual-artefact-container"
            ]
        },
        "contents": {
            "type": "array",
            "items": {
                "anyOf": [
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/location.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/reference-link.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json"
                    }
                ]
            }
        }
    },
    "required": [
        "type",
        "contents"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dHVhbC1hcnRlZmFjdC1jb250YWluZXIuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy90ZXh0dWFsLWFydGVmYWN0LWNvbnRhaW5lci5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxLQUFLLEVBQUUsbUZBQW1GO0lBQzFGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLDBCQUEwQjtJQUNuQyxhQUFhLEVBQUUsOEVBQThFO0lBQzdGLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHVDQUF1QzthQUN4QztTQUNGO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsTUFBTSxFQUFFLE9BQU87WUFDZixPQUFPLEVBQUU7Z0JBQ1AsT0FBTyxFQUFFO29CQUNQO3dCQUNFLE1BQU0sRUFBRSxRQUFRO3dCQUNoQixNQUFNLEVBQUUsa0VBQWtFO3FCQUMzRTtvQkFDRDt3QkFDRSxNQUFNLEVBQUUsUUFBUTt3QkFDaEIsTUFBTSxFQUFFLGlFQUFpRTtxQkFDMUU7b0JBQ0Q7d0JBQ0UsTUFBTSxFQUFFLFFBQVE7d0JBQ2hCLE1BQU0sRUFBRSx1RUFBdUU7cUJBQ2hGO29CQUNEO3dCQUNFLE1BQU0sRUFBRSxRQUFRO3dCQUNoQixNQUFNLEVBQUUsNkRBQTZEO3FCQUN0RTtvQkFDRDt3QkFDRSxNQUFNLEVBQUUsUUFBUTt3QkFDaEIsTUFBTSxFQUFFLGlFQUFpRTtxQkFDMUU7aUJBQ0Y7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sVUFBVTtLQUNYO0NBQ0YsQ0FBQSJ9